module.exports = __webpack_public_path__ + "static/media/arrow2.1cb61725.png";